/* eslint-disable no-unused-vars */
import BaaS from 'minapp-sdk';

var timeOut = '网络连接失败，请稍后重试'
var Bus = BaaS.storage

// 注册
function userRegister(username, password) {
    return BaaS.auth.register({ username, password }).then(user => {
        return {
            code: 200,
            data: user
        }
    }).catch(err => {
        if (err.code == 400) {
            return {
                code: 400,
                data: '账户名重复，请更改后重试'
            }
        } else {
            return {
                code: 600,
                data: timeOut
            }
        }
    })
}

// 登录
function userLogin(username, password) {
    return BaaS.auth.login({ username, password }).then(user => {
        return {
            code: 200,
            data: user
        }
    }).catch(err => {
        if (err.code == 400) {
            return {
                code: 400,
                data: '用户名或密码错误，请检查重试'
            }
        } else {
            return {
                code: 600,
                data: timeOut
            }
        }
    })
}

// 当前用户
function currentUser() {
    return BaaS.auth.getCurrentUser().then(user => {
        return {
            code: 200,
            data: user
        }
    }).catch(err => {
        if (err.code === 604) {
            return {
                code: 604,
                data: '用户未登录'
            }
        } else {
            return {
                code: 600,
                data: timeOut
            }
        }
    })
}

// 添加数据
function addData(tableName, data) {
    let table = new BaaS.TableObject(tableName)
    let row = table.create()
    return row.set(data).save().then(res => {
        return {
            code: 200,
            data: res
        }
    }, err => {
        return {
            code: 400,
            data: '数据新增失败，请检查网络'
        }
    })
}

// 删除数据
function deleteData(tableName, recordID) {
    let table = new BaaS.TableObject(tableName)
    return table.delete(recordID).then(res => {
        return {
            code: 200,
            data: res
        }
    }, err => {
        return {
            code: 400,
            data: '数据删除失败，请检查网络'
        }
    })
}

// 更新数据
function updateData(tableName, recordID, obj, data) {
    let table = new BaaS.TableObject(tableName)
    let row = table.getWithoutData(recordID)
    if (data) {
        // 更新单个字段
        row.set(obj, data)
    } else {
        // 更新多个字段
        row.set(obj)
    }
    return row.update().then(res => {
        return {
            code: res.statusCode,
            data: res.data
        }
    }, err => {
        return {
            code: err.code,
            data: '数据更新失败，请检查网络'
        }
    })
}

// 查询数据
function findData(tableName, query, arr, offset) {
    let table = new BaaS.TableObject(tableName)
    function find() {
        if (offset) {
            return table.setQuery(query).select(arr).limit(200).offset(offset).orderBy(['-created_at']).find()
        } else {
            return table.setQuery(query).limit(200).orderBy(['-created_at']).find()
        }
    }
    return find().then(res => {
        return {
            code: res.statusCode,
            data: res.data
        }
    }, err => {
        return {
            code: err.code,
            data: '数据查询失败，请检查网络'
        }
    })

}

export {
    userRegister,
    userLogin,
    currentUser,
    addData,
    deleteData,
    updateData,
    findData,
    Bus
}